import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import {BrowserRouter as Router} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import './index.css';
import {Provider} from 'react-redux';
import store from './redux/store';

ReactDOM.render(
<Provider store={store}>
    <Router>
        <React.StrictMode>
            <App />
        </React.StrictMode>
    </Router>
</Provider>, 
document.getElementById('root'));